import { Damages } from '~/features/Inspection/Damages'
import {
  QuickNavigation,
  QuickNavigationOptions,
} from '~/shared/ui/QuickNavigation'

const quickNavigationOptions: QuickNavigationOptions = [
  { labelI18n: 'damages map', anchor: 'damagesMap' },
  { labelI18n: 'damages new', anchor: 'damagesNew' },
  { labelI18n: 'damages history', anchor: 'damagesHistory' },
]

export function DamagesPage() {
  return (
    <>
      <Damages />
      <QuickNavigation options={quickNavigationOptions} />
    </>
  )
}
